export default __webpack_public_path__ + "static/media/catalogs.25b23671.svg";